<div [ngClass]="{'medium': isMedium}"><strong>{{title}} : </strong>{{data}}<ng-content></ng-content></div>
